import React from "react"
import {
  Box,
  Container,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography
} from "@mui/material"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined"
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined"
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined"

const CSAEPolicy = () => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "background.default",
        backgroundImage:
          "radial-gradient(1200px 600px at 10% 0%, rgba(25, 118, 210, 0.10), transparent 60%), radial-gradient(900px 500px at 90% 10%, rgba(156, 39, 176, 0.10), transparent 55%)",
        py: { xs: 6, md: 10 }
      }}>
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 4,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper"
          }}>
          <Stack spacing={3}>
            <Stack spacing={1}>
              <Typography variant="overline" sx={{ letterSpacing: 2, color: "text.secondary" }}>
                Safety and Trust
              </Typography>
              <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
                Child Sexual Abuse and Exploitation (CSAE) Policy
              </Typography>
              <Typography variant="body1" color="text.secondary">
                We have zero tolerance for child sexual abuse and exploitation. This policy applies to all users,
                content, and interactions in our app.
              </Typography>
            </Stack>

            <Divider />

            <Stack spacing={1.5}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Prohibited content and behavior
              </Typography>
              <List disablePadding>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckCircleOutlineIcon color="error" />
                  </ListItemIcon>
                  <ListItemText primary="Any sexual content involving minors." />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckCircleOutlineIcon color="error" />
                  </ListItemIcon>
                  <ListItemText primary="Child sexual abuse material (CSAM) in any form." />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckCircleOutlineIcon color="error" />
                  </ListItemIcon>
                  <ListItemText primary="Grooming, solicitation, or exploitation of minors." />
                </ListItem>
              </List>
            </Stack>

            <Stack spacing={1.5}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Enforcement
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <ReportProblemOutlinedIcon color="warning" />
                <Typography variant="body1" color="text.secondary">
                  We actively moderate content and remove violations immediately. Accounts involved in CSAE are
                  permanently banned and reported to authorities where required.
                </Typography>
              </Stack>
            </Stack>

            <Stack spacing={1.5}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Reporting
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <ContactMailOutlinedIcon color="primary" />
                <Typography variant="body1" color="text.secondary">
                  Users can report inappropriate content directly within the app or by contacting{" "}
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    support@brostrike.com
                  </Box>
                  .
                </Typography>
              </Stack>
            </Stack>

            <Stack spacing={1.5}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Legal compliance
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <GavelOutlinedIcon color="action" />
                <Typography variant="body1" color="text.secondary">
                  We comply with all applicable child safety laws and cooperate with law enforcement.
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </Box>
  )
}

export default CSAEPolicy
